export default{
  loading:false,
  canJoinAct:false,
  codeTime:60,
  codeSended:false,
  cancelTokenArr:[],
  hadRefreshLogin:false,
  enrollStatus:'no_enroll',//no_enroll 未报名  enrolled 已报名 act_no_start  活动未开始  act_ended 活动已结束
  actName:'',
  actShareData:null,
  seckillItem:null,
}